import classNames from "classnames";
import { AudioPlayer } from "components/AudioPlayer/AudioPlayer";
import { VideoPlayer } from "components/VideoPlayer/VideoPlayer";
import { MEDIA_TYPE } from "constant";
import { useState } from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import Magnifier from "react-magnifier";
import "./question-media.css"

export const QuestionMedia = ({
  media,
  onMediaLoad,
  questionLength,
  isWidthAuto,
  isQuesMCQWithImageOptions,
  isMcq = false,
  spotlightOrgFlag = false,
}) => {

  const [mediaPopup, setMediaPopup] = useState(false);

  return media?.length > 0
    ? media.map((data) => {
      switch (data.mediaType) {
        case MEDIA_TYPE.IMAGE:
          return (
            <>
              {/* <div className={classNames({
                "relative": isMcq && spotlightOrgFlag
              })}> */}
              <img
                key={data.mediaId}
                className={
                  classNames(
                    "cursor-pointer",
                    {
                      "h-full": isQuesMCQWithImageOptions,
                      "w-full": !isQuesMCQWithImageOptions
                    },
                    {
                      "sm:m-auto sm:w-auto": isWidthAuto,
                    },
                    {
                      "w-[95%]": isMcq && spotlightOrgFlag
                    }
                  )}
                onLoad={onMediaLoad}
                src={data.mediaUrl}
                alt="question"
                onClick={(isMcq && spotlightOrgFlag) ? () => { } : () => setMediaPopup(true)}
              />
              {/* {
                  isMcq && spotlightOrgFlag
                    ? <div className={classNames("spotlight-gradient")} />
                    : <></>
                } */}
              {/* </div> */}
              {mediaPopup &&
                <div
                  className="absolute top-0 left-0 z-10 h-full w-full flex items-center justify-center bg-[#0001] before:absolute before:top-0 before:left-0 before:h-full before:w-full before:backdrop-blur-md"
                  onClick={() => setMediaPopup(false)}
                >
                  <div className="hidden sm:block sm:h-full">
                    <div className="magnifier-close-icon desktop absolute z-20 right-0 cursor-pointer">
                      <AiFillCloseCircle />
                    </div>
                    <Magnifier src={data.mediaUrl} width={'auto'} height={'100%'} />
                  </div>
                  <div className="sm:hidden">
                    <div className="magnifier-close-icon absolute z-20 right-0 top-[-1px]">
                      <AiFillCloseCircle style={{ fontSize: "32px" }} />
                    </div>
                    <img
                      key={data.mediaId}
                      className={"sm:hidden w-auto sm:w-[unset] sm:h-[90%] relative z-10"}
                      onLoad={onMediaLoad}
                      src={data.mediaUrl}
                      alt="question"
                    />
                  </div>
                </div>
              }
            </>
          );

        case MEDIA_TYPE.VIDEO:
          return (
            <video
              key={data.mediaId}
              autoPlay
              controls
              className={classNames(
                "m-auto max-h-[calc(100vh-300px)]",
                "sm:w-full",
              )}
            >
              <source src={data.mediaUrl} />
              Sorry, your browser doesn't support embedded videos.
            </video>
          );

        case MEDIA_TYPE.AUDIO:
          return (
            <AudioPlayer key={data.mediaId} src={data.mediaUrl} autoPlayDelay={2} />
          );

        case MEDIA_TYPE.EMBED:
          return (
            <VideoPlayer
              key={data.mediaUrl}
              src={data.mediaUrl}
              className="min-h-[300px]"
              isQuestionEmbed
            />
          );

        default:
          return null;
      }
    })
    : null;
};
